import styled from 'styled-components';

export const Separator = styled.hr`
  border-bottom-color: ${(props) => props.theme.separator.color};
  border-bottom-style: ${(props) => props.theme.separator.style};
  border-bottom-width: ${(props) => props.theme.separator.width};
  width: 100%;
`;
